<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm" label-width="100%" label-position="top">
          <b-row>
            <iframe title="Main content" :src="mData.dataDefault.links" width="100%"  frameborder="0"
              style="z-index: 10; height:calc(100vh - 195px);"></iframe>
          </b-row>
          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DDATModel from "./DDATModel";
import DDATApi from "../../../moduleApi/DDATApi";
import SurveyApi from "../../../moduleApi/SurveyApi";
import mushroomDulich from "../../../service/api/dulich-api";
import config from "../../../config.json";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "update",
        moduleName: "ThongTinDDAT",
        dataDefault: {
          roles: DataService.rolesInForm,
          links: "",
          iframe: {
            src: "",
            style: null,
            wrapperStyle: null,
          },
        },
        dataForm: MethodService.copyObject(DDATModel.dataForm),
        validForm: DDATModel.validForm,
        dialog: {},
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await DDATApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await DDATApi.update(this.mData.dataForm);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DDATApi.findById(id);
      this.mData.dataForm = res.result;

      let objJsonB64 = "";
      let prefillSurvey;
      if (res.result.du_lieu_khai_bao) {
        objJsonB64 = Buffer.from(
          JSON.stringify(res.result.du_lieu_khai_bao)
        ).toString("base64");
        prefillSurvey = await SurveyApi.getPrefillId({ data: objJsonB64 });
      }
      let pathLocation =
        location.protocol + "//" + location.host + "/admin/UpdateDDAT/success";

      let params = {
        prefillData: prefillSurvey.result,
        appCode: "Tourism",
        callbackUrl: pathLocation,
        env: config.surveyDailyEnv
      };
      mushroomDulich.user.generateHashCodeAsync({
        body: params
      }).then(async res => {
        if (res.result && res.result.length > 0) {
          this.mData.dataDefault.links +=
            config.surveyEnv +
            "prefillId=" +
            prefillSurvey.result +
            "&hashCode=" +
            res.result.toString().toLowerCase() +
            "&appCode=Tourism" +
            "&env=" + config.surveyDailyEnv +
            "&callbackUrl=" +
            encodeURIComponent(pathLocation);
        }
      })
    },

    async fn_initDataDefault() { },

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },
  },
  created: function () {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    } else if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {
    window.redirectToDangKyDDAT = async (url) => {
      DDATApi.clearCache();
      this.currentUser = MethodService.getCurrentUser();
      let res = await DDATApi.list({ filters: 'nguoi_tao_id=' + this.currentUser.id, fields: "loai_diem_den" });
      if (res.result && res.result.length > 0) {
        if (!('hotel,tourist_villa,tourist_apartment,tourist_cruise,motel,homestay'.includes(res.result[0].loai_diem_den))) {
          $(".fa-calendar-check-o").parent().hide();
          $(".icon-calendar").parent().hide();
        }
        else {
          $(".fa-calendar-check-o").parent().show();
          $(".icon-calendar").parent().show();
        }
      }
      window.toastr.success("Cập nhật thông tin thành công");
      this.$router.push(url);
      setTimeout(() => {
        window.parent.location.href = url;
      }, 1500)
    }
  },
};
</script>
<style scoped>
.card {
  position: relative;
  margin-bottom: 0;
}

.card::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 70%;
  background-image: url("~/img/safe-travel.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.1;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
